import { create } from 'zustand';

export interface UserProfile {
  id: string;
  username: string;
  email: string;
  profiles: string[];
  permissions: string[];
  isAdmin: boolean;
  isSuperAdmin: boolean;
}

export interface AuthState {
  user: UserProfile | null;
  isAuthenticated: boolean;
  isLoadingMe: boolean;
  /** Nombre de pila de `/Seguridad/profile` (lo carga LayoutTemplate); `/Seguridad/me` no trae nombre. */
  firstName: string | null;

  // Acciones
  setUser: (user: UserProfile | null) => void;
  setFirstName: (firstName: string | null) => void;
  setLoadingMe: (loading: boolean) => void;
  clearAuth: () => void;

  // Helpers de Verificación
  hasRole: (role: string | string[]) => boolean;
  hasPermission: (permission: string | string[]) => boolean;
  isAdmin: () => boolean;
}

export const useAuthStore = create<AuthState>((set, get) => ({
  user: null,
  isAuthenticated: false,
  isLoadingMe: true,
  firstName: null,
  setUser: (user) => {
    set({
      user,
      isAuthenticated: !!user,
      isLoadingMe: false,
    });
  },
  setLoadingMe: (isLoadingMe) => set({ isLoadingMe }),
  setFirstName: (firstName) => set({ firstName }),
  clearAuth: () => {
    set({
      user: null,
      firstName: null,
      isAuthenticated: false,
      isLoadingMe: false,
    });
  },
  hasRole: (roles) => {
    if (get().user?.isAdmin) return true;

    const userProfiles = get().user?.profiles ?? [];
    if (Array.isArray(roles)) {
      return roles.some((role) => userProfiles.includes(role));
    }
    return userProfiles.includes(roles);
  },

  hasPermission: (permissions) => {
    if (get().user?.isAdmin) return true;

    const userPermissions = get().user?.permissions ?? [];

    if (Array.isArray(permissions)) {
      return permissions.some((perm) => userPermissions.includes(perm));
    }
    return userPermissions.includes(permissions);
  },
  isAdmin: () => get().user?.isAdmin ?? false,
}));
